import React from "react";

export const Deposit = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_15_8676)">
        <g clip-path="url(#clip1_15_8676)">
          <path
            d="M13.2191 11.5156L10.3906 14.3441L7.5622 11.5156"
            stroke="#FF7028"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M16.6038 1.34863H4.33594C3.23137 1.34863 2.33594 2.24406 2.33594 3.34863V16.0156C2.33594 17.1202 3.23137 18.0156 4.33594 18.0156H16.6038C17.7084 18.0156 18.6038 17.1202 18.6038 16.0156V3.34863C18.6038 2.24406 17.7084 1.34863 16.6038 1.34863Z"
            stroke="#DEDEDE"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10.3906 5.51562V13.5156"
            stroke="#FF7028"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_15_8676">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.890625 0.015625)"
          />
        </clipPath>
        <clipPath id="clip1_15_8676">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.890625 0.015625)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Help = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_15_8690)">
        <g clip-path="url(#clip1_15_8690)">
          <path
            d="M2.20312 9.58849H19.0655"
            stroke="#FF7028"
            stroke-linecap="square"
          />
          <path
            d="M10.8002 18.5156C15.7305 18.5156 19.7273 14.5188 19.7273 9.58849C19.7273 4.65817 15.7305 0.661358 10.8002 0.661358C5.86986 0.661358 1.87305 4.65817 1.87305 9.58849C1.87305 14.5188 5.86986 18.5156 10.8002 18.5156Z"
            stroke="#DEDEDE"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10.7996 18.5156C12.9909 18.5156 14.7673 14.5188 14.7673 9.58849C14.7673 4.65817 12.9909 0.661358 10.7996 0.661358C8.60839 0.661358 6.83203 4.65817 6.83203 9.58849C6.83203 14.5188 8.60839 18.5156 10.7996 18.5156Z"
            stroke="#FF7028"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_15_8690">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.390625 0.015625)"
          />
        </clipPath>
        <clipPath id="clip1_15_8690">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.390625 0.015625)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Sun = () => {
  return (
    <svg
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_15_8704)">
        <g clip-path="url(#clip1_15_8704)">
          <g clip-path="url(#clip2_15_8704)">
            <path
              d="M11.4042 16.1927C14.8204 16.1927 17.5897 13.4234 17.5897 10.0073C17.5897 6.59111 14.8204 3.82178 11.4042 3.82178C7.98808 3.82178 5.21875 6.59111 5.21875 10.0073C5.21875 13.4234 7.98808 16.1927 11.4042 16.1927Z"
              stroke="#FF7028"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.1719 0.938004V2.24586"
              stroke="#EBEBEB"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M17.6533 3.43L16.7285 4.3548"
              stroke="#EBEBEB"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M20.4746 9.77486H19.1668"
              stroke="#EBEBEB"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M17.9834 16.2559L17.0586 15.3311"
              stroke="#EBEBEB"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.6367 19.0765V17.7687"
              stroke="#EBEBEB"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M5.15625 16.5845L6.08104 15.6597"
              stroke="#EBEBEB"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M2.33594 10.2396H3.6438"
              stroke="#EBEBEB"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M4.82812 3.75865L5.75292 4.68345"
              stroke="#EBEBEB"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_15_8704">
          <rect
            width="21"
            height="20"
            fill="white"
            transform="translate(0.890625 0.015625)"
          />
        </clipPath>
        <clipPath id="clip1_15_8704">
          <rect
            width="21"
            height="20"
            fill="white"
            transform="translate(0.890625 0.015625)"
          />
        </clipPath>
        <clipPath id="clip2_15_8704">
          <rect
            width="21"
            height="20"
            fill="white"
            transform="translate(0.890625 0.015625)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Drop = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.58751 2.625C2.19376 2.625 1.87502 2.96101 1.87502 3.37501C1.87502 3.78901 2.19376 4.12501 2.58751 4.12501H15.4125C15.8063 4.12501 16.125 3.78901 16.125 3.37501C16.125 2.96101 15.8063 2.625 15.4125 2.625H2.58751ZM2.58751 13.875C2.19376 13.875 1.87502 14.211 1.87502 14.625C1.87502 15.039 2.19376 15.375 2.58751 15.375H15.4125C15.8063 15.375 16.125 15.039 16.125 14.625C16.125 14.211 15.8063 13.875 15.4125 13.875H2.58751ZM16.02 8.25675L14.3123 10.305C14.2787 10.345 14.2392 10.3796 14.1953 10.4078C13.9538 10.563 13.6148 10.5173 13.4378 10.305L11.73 8.25751C11.6632 8.17895 11.6263 8.07935 11.6258 7.97626C11.6258 7.71376 11.868 7.50077 12.1673 7.50077H15.5843C15.699 7.50077 15.8115 7.53301 15.9038 7.593C16.1453 7.74751 16.1978 8.04525 16.0208 8.25751L16.02 8.25675ZM2.62501 8.25C2.52651 8.25 2.42899 8.2694 2.33799 8.30709C2.247 8.34478 2.16432 8.40003 2.09467 8.46967C2.02503 8.53932 1.96978 8.622 1.93209 8.71299C1.8944 8.80399 1.875 8.90151 1.875 9.00001C1.875 9.0985 1.8944 9.19603 1.93209 9.28702C1.96978 9.37802 2.02503 9.4607 2.09467 9.53034C2.16432 9.59998 2.247 9.65523 2.33799 9.69292C2.42899 9.73061 2.52651 9.75001 2.62501 9.75001H9.37501C9.57392 9.75001 9.76469 9.67099 9.90534 9.53034C10.046 9.38969 10.125 9.19892 10.125 9.00001C10.125 8.80109 10.046 8.61033 9.90534 8.46967C9.76469 8.32902 9.57392 8.25 9.37501 8.25H2.62501Z" fill="#000" />
    </svg>

  );
};

export const Drop2 = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.58751 2.625C2.19376 2.625 1.87502 2.96101 1.87502 3.37501C1.87502 3.78901 2.19376 4.12501 2.58751 4.12501H15.4125C15.8063 4.12501 16.125 3.78901 16.125 3.37501C16.125 2.96101 15.8063 2.625 15.4125 2.625H2.58751ZM2.58751 13.875C2.19376 13.875 1.87502 14.211 1.87502 14.625C1.87502 15.039 2.19376 15.375 2.58751 15.375H15.4125C15.8063 15.375 16.125 15.039 16.125 14.625C16.125 14.211 15.8063 13.875 15.4125 13.875H2.58751ZM16.02 8.25675L14.3123 10.305C14.2787 10.345 14.2392 10.3796 14.1953 10.4078C13.9538 10.563 13.6148 10.5173 13.4378 10.305L11.73 8.25751C11.6632 8.17895 11.6263 8.07935 11.6258 7.97626C11.6258 7.71376 11.868 7.50077 12.1673 7.50077H15.5843C15.699 7.50077 15.8115 7.53301 15.9038 7.593C16.1453 7.74751 16.1978 8.04525 16.0208 8.25751L16.02 8.25675ZM2.62501 8.25C2.52651 8.25 2.42899 8.2694 2.33799 8.30709C2.247 8.34478 2.16432 8.40003 2.09467 8.46967C2.02503 8.53932 1.96978 8.622 1.93209 8.71299C1.8944 8.80399 1.875 8.90151 1.875 9.00001C1.875 9.0985 1.8944 9.19603 1.93209 9.28702C1.96978 9.37802 2.02503 9.4607 2.09467 9.53034C2.16432 9.59998 2.247 9.65523 2.33799 9.69292C2.42899 9.73061 2.52651 9.75001 2.62501 9.75001H9.37501C9.57392 9.75001 9.76469 9.67099 9.90534 9.53034C10.046 9.38969 10.125 9.19892 10.125 9.00001C10.125 8.80109 10.046 8.61033 9.90534 8.46967C9.76469 8.32902 9.57392 8.25 9.37501 8.25H2.62501Z" fill="white" />
    </svg>

  );
};

export const Info = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.74952 0.666496C12.7995 0.666496 16.083 3.9495 16.083 8C16.083 12.0505 12.8 15.3335 8.74952 15.3335C4.69952 15.3335 1.41602 12.0505 1.41602 8C1.41602 3.9495 4.69902 0.666496 8.74952 0.666496ZM8.91252 6.015H8.24602C8.06925 6.015 7.89972 6.08522 7.77473 6.21021C7.64974 6.3352 7.57952 6.50473 7.57952 6.6815C7.57952 6.85826 7.64974 7.02779 7.77473 7.15278C7.89972 7.27778 8.06925 7.348 8.24602 7.348V10.6815H7.74202C7.56525 10.6815 7.39572 10.7517 7.27073 10.8767C7.14574 11.0017 7.07552 11.1712 7.07552 11.348C7.07552 11.5248 7.14574 11.6943 7.27073 11.8193C7.39572 11.9443 7.56525 12.0145 7.74202 12.0145H10.086C10.2628 12.0145 10.4323 11.9443 10.5573 11.8193C10.6823 11.6943 10.7525 11.5248 10.7525 11.348C10.7525 11.1712 10.6823 11.0017 10.5573 10.8767C10.4323 10.7517 10.2628 10.6815 10.086 10.6815H9.57902V6.6815C9.57902 6.3135 9.28052 6.015 8.91252 6.015ZM8.75402 3.6655C8.64215 3.66276 8.53086 3.68244 8.42671 3.72336C8.32256 3.76429 8.22765 3.82563 8.14756 3.90379C8.06747 3.98194 8.00383 4.07533 7.96037 4.17845C7.91692 4.28157 7.89454 4.39234 7.89454 4.50425C7.89454 4.61615 7.91692 4.72692 7.96037 4.83004C8.00383 4.93316 8.06747 5.02655 8.14756 5.10471C8.22765 5.18286 8.32256 5.24421 8.42671 5.28513C8.53086 5.32605 8.64215 5.34573 8.75402 5.343C8.97292 5.33765 9.18106 5.24694 9.33399 5.09022C9.48693 4.93351 9.57254 4.72322 9.57254 4.50425C9.57254 4.28528 9.48693 4.07498 9.33399 3.91827C9.18106 3.76156 8.97292 3.67084 8.75402 3.6655Z"
        fill="#8C8C8C"
        fill-opacity="0.6"
      />
    </svg>
  );
};

export const Wifi = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.05273 7.82913C6.93428 2.94758 14.8489 2.94758 19.7304 7.82913"
        stroke="#F8B200"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M4.99805 10.7767C8.25242 7.52235 13.5288 7.52234 16.7832 10.7767"
        stroke="#F8B200"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M7.65039 13.6706C9.44029 11.8806 12.3423 11.8806 14.1322 13.6706"
        stroke="#F8B200"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M10.8906 16.668H10.899"
        stroke="#F8B200"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
};

export const Msg = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2233 6V12.0007C16.2233 12.7079 15.9424 13.3862 15.4423 13.8863C14.9422 14.3864 14.2639 14.6673 13.5566 14.6673H4.22331C3.51606 14.6673 2.83779 14.3864 2.33769 13.8863C1.83759 13.3862 1.55664 12.7079 1.55664 12.0007V6.17933C1.55664 6.062 1.56264 5.83933 1.56264 5.83933L3.57997 5.80333L8.12531 8.98466C8.34943 9.14156 8.61639 9.22572 8.88997 9.22572C9.16356 9.22572 9.43052 9.14156 9.65464 8.98466L14.2 5.80333L16.2233 6ZM14.89 6.94733L10.4193 10.0773C9.97106 10.3911 9.43714 10.5594 8.88997 10.5594C8.34281 10.5594 7.80888 10.3911 7.36064 10.0773L2.88997 6.94666V12C2.88997 12.3536 3.03045 12.6928 3.2805 12.9428C3.53055 13.1929 3.86969 13.3333 4.22331 13.3333H13.5566C13.9103 13.3333 14.2494 13.1929 14.4994 12.9428C14.7495 12.6928 14.89 12.3536 14.89 12V6.94733Z"
        fill="#8C8C8C"
        fill-opacity="0.36"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.2685 2.404C9.15717 2.32716 9.0251 2.28602 8.88983 2.28602C8.75457 2.28602 8.6225 2.32716 8.51117 2.404L3.57983 5.80333L1.5625 5.83933C1.5625 5.83933 1.61117 5.662 1.6745 5.566C1.72783 5.48266 1.84517 5.37933 1.84517 5.37933L7.75517 1.306C8.08889 1.07608 8.48458 0.952972 8.88983 0.952972C9.29509 0.952972 9.69078 1.07608 10.0245 1.306L15.9345 5.37933C16.2232 5.66666 16.2232 6 16.2232 6L14.1998 5.80333L9.2685 2.404Z"
        fill="#8C8C8C"
        fill-opacity="0.36"
      />
    </svg>
  );
};

export const Trading = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.03883 0.666664C4.3155 0.666664 2.92017 1.00666 1.97417 1.95333C1.0275 2.89933 0.6875 4.29466 0.6875 6.018V9.982C0.6875 11.7053 1.0275 13.1007 1.97417 14.0467C2.92017 14.9933 4.3155 15.3333 6.03883 15.3333H10.0028C11.7262 15.3333 13.1215 14.9933 14.0675 14.0467C15.0142 13.1007 15.3542 11.7053 15.3542 9.982V6.018C15.3542 4.29466 15.0142 2.89933 14.0675 1.95333C13.1215 1.00666 11.7262 0.666664 10.0028 0.666664H6.03883ZM2.14083 6.018C2.14083 4.438 2.46083 3.52133 3.0015 2.98066C3.5415 2.44066 4.45883 2.12066 6.03883 2.12066H10.0028C11.5828 2.12066 12.4995 2.44066 13.0402 2.98066C13.5802 3.52066 13.9002 4.438 13.9002 6.018V9.982C13.9002 11.562 13.5802 12.4787 13.0402 13.0193C12.5002 13.5593 11.5828 13.8793 10.0028 13.8793H6.03883C4.45883 13.8793 3.54217 13.5593 3.0015 13.0193C2.4615 12.4793 2.1415 11.562 2.1415 9.982L2.14083 6.018ZM8.7475 6.01933C8.7475 5.82661 8.67094 5.64178 8.53466 5.5055C8.39839 5.36922 8.21356 5.29266 8.02083 5.29266C7.82811 5.29266 7.64328 5.36922 7.507 5.5055C7.37073 5.64178 7.29417 5.82661 7.29417 6.01933V10.4327C7.29417 10.6254 7.37073 10.8102 7.507 10.9465C7.64328 11.0828 7.82811 11.1593 8.02083 11.1593C8.21356 11.1593 8.39839 11.0828 8.53466 10.9465C8.67094 10.8102 8.7475 10.6254 8.7475 10.4327V6.01933ZM5.44417 7.16933C5.44417 6.97661 5.36761 6.79178 5.23133 6.6555C5.09505 6.51922 4.91022 6.44266 4.7175 6.44266C4.52478 6.44266 4.33995 6.51922 4.20367 6.6555C4.06739 6.79178 3.99083 6.97661 3.99083 7.16933V9.28266C3.99083 9.47539 4.06739 9.66022 4.20367 9.7965C4.33995 9.93277 4.52478 10.0093 4.7175 10.0093C4.91022 10.0093 5.09505 9.93277 5.23133 9.7965C5.36761 9.66022 5.44417 9.47539 5.44417 9.28266V7.16933ZM11.3242 6.44266C11.7255 6.44266 12.0508 6.768 12.0508 7.16933V9.28266C12.0508 9.47539 11.9743 9.66022 11.838 9.7965C11.7017 9.93277 11.5169 10.0093 11.3242 10.0093C11.1314 10.0093 10.9466 9.93277 10.8103 9.7965C10.6741 9.66022 10.5975 9.47539 10.5975 9.28266V7.16933C10.5975 6.768 10.9228 6.44266 11.3242 6.44266Z"
        fill="#8C8C8C"
        fill-opacity="0.36"
      />
    </svg>
  );
};

export const M1 = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7461 4.97125C9.95044 4.97125 9.18738 5.28732 8.62477 5.84993C8.06216 6.41254 7.74609 7.1756 7.74609 7.97125C7.74609 8.17016 7.82511 8.36092 7.96576 8.50158C8.10642 8.64223 8.29718 8.72125 8.49609 8.72125C8.69501 8.72125 8.88577 8.64223 9.02642 8.50158C9.16708 8.36092 9.24609 8.17016 9.24609 7.97125C9.24609 7.67457 9.33407 7.38457 9.49889 7.13789C9.66371 6.89122 9.89798 6.69896 10.1721 6.58543C10.4462 6.4719 10.7478 6.44219 11.0387 6.50007C11.3297 6.55795 11.597 6.70081 11.8068 6.91059C12.0165 7.12037 12.1594 7.38764 12.2173 7.67861C12.2751 7.96958 12.2454 8.27118 12.1319 8.54527C12.0184 8.81936 11.8261 9.05363 11.5794 9.21845C11.3328 9.38327 11.0428 9.47125 10.7461 9.47125C10.5472 9.47125 10.3564 9.55026 10.2158 9.69092C10.0751 9.83157 9.99609 10.0223 9.99609 10.2212V11.7212C9.99609 11.9202 10.0751 12.1109 10.2158 12.2516C10.3564 12.3922 10.5472 12.4712 10.7461 12.4712C10.945 12.4712 11.1358 12.3922 11.2764 12.2516C11.4171 12.1109 11.4961 11.9202 11.4961 11.7212V10.8769C12.2039 10.695 12.821 10.2611 13.2315 9.65648C13.642 9.05189 13.8177 8.31825 13.7256 7.59329C13.6336 6.86833 13.2801 6.2019 12.7314 5.71912C12.1828 5.23634 11.4769 4.97041 10.7461 4.97125ZM10.7461 15.0962C10.9948 15.0962 11.2333 14.9973 11.4091 14.8213C11.585 14.6454 11.6837 14.4068 11.6836 14.1581C11.6835 13.9094 11.5846 13.6709 11.4087 13.4951C11.2328 13.3193 10.9942 13.2205 10.7455 13.2206C10.6223 13.2207 10.5004 13.245 10.3866 13.2921C10.2728 13.3393 10.1695 13.4084 10.0824 13.4955C9.99537 13.5826 9.92633 13.686 9.87924 13.7998C9.83214 13.9136 9.80793 14.0356 9.80797 14.1587C9.80801 14.2819 9.83231 14.4038 9.87948 14.5176C9.92664 14.6314 9.99576 14.7347 10.0829 14.8218C10.17 14.9088 10.2734 14.9779 10.3872 15.025C10.501 15.0721 10.6229 15.0963 10.7461 15.0962Z"
        fill="#8C8C8C"
      />
      <path
        d="M6.66602 0.833122H14.9991C15.8831 0.833122 16.7309 1.18429 17.356 1.80937C17.9811 2.43445 18.3323 3.28225 18.3323 4.16625V15.8331C18.3323 16.7171 17.9811 17.5649 17.356 18.19C16.7309 18.8151 15.8831 19.1662 14.9991 19.1662H6.66602C5.78202 19.1662 4.93422 18.8151 4.30914 18.19C3.68406 17.5649 3.33289 16.7171 3.33289 15.8331V15H2.09289C1.87193 15 1.66002 14.9122 1.50378 14.756C1.34754 14.5997 1.25977 14.3878 1.25977 14.1669C1.25977 13.9459 1.34754 13.734 1.50378 13.5778C1.66002 13.4215 1.87193 13.3337 2.09289 13.3337H3.33289V10.8337H2.09289C1.87193 10.8337 1.66002 10.746 1.50378 10.5897C1.34754 10.4335 1.25977 10.2216 1.25977 10.0006C1.25977 9.77966 1.34754 9.56776 1.50378 9.41151C1.66002 9.25527 1.87193 9.1675 2.09289 9.1675H3.33289V6.6675H2.09289C1.87193 6.6675 1.66002 6.57972 1.50378 6.42348C1.34754 6.26724 1.25977 6.05533 1.25977 5.83437C1.25977 5.61341 1.34754 5.40151 1.50378 5.24526C1.66002 5.08902 1.87193 5.00125 2.09289 5.00125H3.33289V4.16812C3.33289 3.28412 3.68406 2.43633 4.30914 1.81125C4.93422 1.18616 5.78202 0.834997 6.66602 0.834997V0.833122ZM4.99914 15.8331C4.99914 16.2752 5.17476 16.6992 5.48736 17.0118C5.79996 17.3244 6.22393 17.5 6.66602 17.5H14.9991C15.4412 17.5 15.8652 17.3244 16.1778 17.0118C16.4904 16.6992 16.666 16.2752 16.666 15.8331V4.16625C16.666 3.72416 16.4904 3.30019 16.1778 2.98759C15.8652 2.67499 15.4412 2.49937 14.9991 2.49937H6.66602C6.22393 2.49937 5.79996 2.67499 5.48736 2.98759C5.17476 3.30019 4.99914 3.72416 4.99914 4.16625V15.8331Z"
        fill="#8C8C8C"
      />
    </svg>
  );
};
export const M2 = () => {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_15_7675"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="19"
        height="20"
      >
        <path d="M0 0.5H19V19.5H0V0.5Z" fill="white" />
      </mask>
      <g mask="url(#mask0_15_7675)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.96875 4.36755C0.96875 3.59769 1.27458 2.85936 1.81895 2.31498C2.36333 1.7706 3.10166 1.46478 3.87153 1.46478H15.1301C15.8999 1.46478 16.6383 1.7706 17.1827 2.31498C17.727 2.85936 18.0329 3.59769 18.0329 4.36755V15.6272C18.0329 16.397 17.727 17.1354 17.1827 17.6797C16.6383 18.2241 15.8999 18.5299 15.1301 18.5299H3.87153C3.10166 18.5299 2.36333 18.2241 1.81895 17.6797C1.27458 17.1354 0.96875 16.397 0.96875 15.6272V4.36755ZM3.87153 3.04811C3.14319 3.04811 2.55208 3.63922 2.55208 4.36755V15.6272C2.55208 16.3555 3.14319 16.9466 3.87153 16.9466H15.1301C15.8584 16.9466 16.4495 16.3555 16.4495 15.6272V4.36755C16.4495 3.63922 15.8584 3.04811 15.1301 3.04811H3.87153Z"
          fill="#8C8C8C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.6286 7.88888H1.37305V6.30555H17.6286V7.88888Z"
          fill="#8C8C8C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.6113 18.1246V7.67461H13.1947V18.1246H11.6113Z"
          fill="#8C8C8C"
        />
      </g>
    </svg>
  );
};
export const M3 = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.626 1.41H11.628L16.208 4.059C16.223 4.067 16.238 4.076 16.252 4.086L16.275 4.102C16.672 4.37 17.005 4.594 17.262 4.798C17.529 5.009 17.768 5.238 17.94 5.537C18.117 5.842 18.187 6.157 18.22 6.484C18.249 6.785 18.249 7.147 18.249 7.558V12.441C18.249 12.852 18.249 13.213 18.219 13.515C18.187 13.841 18.117 14.157 17.94 14.462C17.768 14.76 17.529 14.99 17.262 15.202C17.005 15.405 16.672 15.629 16.275 15.897L16.252 15.913C16.2377 15.9225 16.223 15.9315 16.208 15.94L11.628 18.588L11.626 18.59C11.141 18.872 10.551 18.991 10.002 18.991C9.45205 18.991 8.86105 18.872 8.37405 18.591L3.78905 15.94C3.77407 15.9312 3.75939 15.9218 3.74505 15.912L3.72105 15.896C3.32505 15.628 2.99205 15.404 2.73505 15.2C2.46805 14.988 2.22905 14.758 2.05705 14.46C1.88005 14.154 1.81005 13.837 1.77705 13.51C1.74805 13.208 1.74805 12.845 1.74805 12.432V7.558C1.74805 7.147 1.74805 6.786 1.77805 6.484C1.81005 6.157 1.88105 5.842 2.05705 5.537C2.22905 5.239 2.46805 5.009 2.73505 4.797C2.99205 4.594 3.32505 4.37 3.72105 4.102L3.74505 4.086C3.7594 4.0765 3.77407 4.06749 3.78905 4.059L8.37305 1.409C8.85905 1.127 9.45105 1.008 10.001 1.008C10.55 1.008 11.141 1.126 11.625 1.409L11.626 1.41ZM10.002 2.508C9.64605 2.508 9.32905 2.588 9.12405 2.708L4.56405 5.344C4.14905 5.624 3.87105 5.813 3.66805 5.974C3.46605 6.134 3.39305 6.224 3.35705 6.287C3.32505 6.342 3.29105 6.427 3.27105 6.63C3.24971 6.94986 3.24237 7.2705 3.24905 7.591V12.4C3.24905 12.857 3.24905 13.145 3.27105 13.366C3.29105 13.571 3.32505 13.656 3.35705 13.712C3.39305 13.775 3.46705 13.867 3.66805 14.026C3.87105 14.187 4.14905 14.376 4.56405 14.656L9.12405 17.293C9.32905 17.411 9.64605 17.493 10.002 17.493C10.359 17.493 10.672 17.411 10.87 17.295L10.874 17.293L15.434 14.656C15.849 14.376 16.127 14.187 16.33 14.026C16.532 13.866 16.605 13.776 16.641 13.713C16.673 13.657 16.707 13.573 16.727 13.369C16.748 13.149 16.749 12.863 16.749 12.409V7.59C16.749 7.136 16.749 6.85 16.727 6.63C16.707 6.426 16.673 6.341 16.641 6.286C16.605 6.224 16.531 6.132 16.331 5.973C16.127 5.812 15.849 5.623 15.434 5.343L10.87 2.704C10.671 2.588 10.359 2.508 10.002 2.508Z"
        fill="#8C8C8C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 8.25C9.77019 8.25 9.54262 8.29527 9.3303 8.38321C9.11798 8.47116 8.92507 8.60006 8.76256 8.76256C8.60006 8.92507 8.47116 9.11798 8.38321 9.3303C8.29527 9.54262 8.25 9.77019 8.25 10C8.25 10.2298 8.29527 10.4574 8.38321 10.6697C8.47116 10.882 8.60006 11.0749 8.76256 11.2374C8.92507 11.3999 9.11798 11.5288 9.3303 11.6168C9.54262 11.7047 9.77019 11.75 10 11.75C10.4641 11.75 10.9092 11.5656 11.2374 11.2374C11.5656 10.9092 11.75 10.4641 11.75 10C11.75 9.53587 11.5656 9.09075 11.2374 8.76256C10.9092 8.43437 10.4641 8.25 10 8.25ZM6.75 10C6.75 9.13805 7.09241 8.3114 7.7019 7.7019C8.3114 7.09241 9.13805 6.75 10 6.75C10.862 6.75 11.6886 7.09241 12.2981 7.7019C12.9076 8.3114 13.25 9.13805 13.25 10C13.25 10.862 12.9076 11.6886 12.2981 12.2981C11.6886 12.9076 10.862 13.25 10 13.25C9.13805 13.25 8.3114 12.9076 7.7019 12.2981C7.09241 11.6886 6.75 10.862 6.75 10Z"
        fill="#8C8C8C"
      />
    </svg>
  );
};

export const L1 = () => {
  return (
    <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2 3H8V9H2V3Z" fill="#EF454A" />
      <path d="M2 11H8V17H2V11Z" fill="#20B26C" />
      <g opacity="0.8">
        <path d="M10 3H18V5H10V3ZM10 7H18V9H10V7ZM10 11H18V13H10V11ZM10 15H18V17H10V15Z" fill="white" />
      </g>
    </svg>
  );
};

export const L2 = () => {
  return (
    <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17 2V8H11V2H17Z" fill="#EF454A" />
      <path d="M9 2V8H3V2H9Z" fill="#20B26C" />
      <g opacity="0.8">
        <path d="M17 10V18H15V10H17ZM13 10V18H11V10H13ZM9 10V18H7V10H9ZM5 10V18H3V10H5Z" fill="white" />
      </g>
      <g opacity="0.4">
        <path d="M17 2V8H11V2H17Z" fill="#EF454A" />
        <path d="M9 2V8H3V2H9Z" fill="#20B26C" />
        <g opacity="0.8">
          <path d="M17 10V18H15V10H17ZM13 10V18H11V10H13ZM9 10V18H7V10H9ZM5 10V18H3V10H5Z" fill="white" />
        </g>
      </g>
    </svg>
  );
};

export const L3 = () => {
  return (
    <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2 3H8V17H2V3Z" fill="#20B26C" />
      <path opacity="0.8" d="M10 3H18V5H10V3ZM10 7H18V9H10V7ZM10 11H18V13H10V11ZM10 15H18V17H10V15Z" fill="white" />
    </svg>

  );
};

export const L4 = () => {
  return (
    <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2 3H8V17H2V3Z" fill="#EF454A" />
      <path opacity="0.8" d="M10 3H18V5H10V3ZM10 7H18V9H10V7ZM10 11H18V13H10V11ZM10 15H18V17H10V15Z" fill="white" />
    </svg>
  );
};

export const Fire = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_15_15828)">
        <g clip-path="url(#clip1_15_15828)">
          <g clip-path="url(#clip2_15_15828)">
            <path
              d="M23.0576 13.2793C23.0576 19.3871 18.1063 24.3384 11.9985 24.3384C5.89079 24.3384 0.939453 19.3871 0.939453 13.2793C0.939453 12.0793 1.28505 9.83505 1.93784 8.68307C1.51545 11.1407 3.31192 14.0551 5.24021 12.8687C6.09937 12.34 6.11911 11.2641 5.24021 10.4111C3.93462 9.14387 3.05144 6.20658 5.24021 3.69111C5.24021 5.87989 7.29251 8.26079 8.96498 7.33922C11.6172 5.87777 9.38738 2.50086 7.62099 1.46407C10.3857 1.11854 14.4269 2.62145 15.1473 6.1488C15.4625 7.69193 16.3614 8.5806 17.7585 8.26078C19.1555 7.94096 18.9873 5.36149 18.3729 4.01751C20.8304 5.66869 23.0576 9.06707 23.0576 13.2793Z"
              fill="url(#paint0_linear_15_15828)"
            />
          </g>
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_15_15828"
          x1="11.9985"
          y1="1.57927"
          x2="11.9985"
          y2="24.3386"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFA25F" />
          <stop offset="1" stop-color="#F5A623" />
        </linearGradient>
        <clipPath id="clip0_15_15828">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(-0.00390625 0.799805)"
          />
        </clipPath>
        <clipPath id="clip1_15_15828">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(-0.00390625 0.799805)"
          />
        </clipPath>
        <clipPath id="clip2_15_15828">
          <rect
            width="23.04"
            height="24"
            fill="white"
            transform="translate(0.476562 0.799805)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Profile = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_15_15813)">
        <g clip-path="url(#clip1_15_15813)">
          <g clip-path="url(#clip2_15_15813)">
            <path
              d="M6.85547 11.19L8.52213 12.8566L11.1888 10.19"
              stroke="var(--clr-font)"
              stroke-width="1.42666"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M8.85438 6.14334C10.3014 6.14334 11.4744 4.97032 11.4744 3.52334C11.4744 2.07635 10.3014 0.903336 8.85438 0.903336C7.40739 0.903336 6.23438 2.07635 6.23438 3.52334C6.23438 4.97032 7.40739 6.14334 8.85438 6.14334Z"
              stroke="var(--clr-font)"
              stroke-width="1.42666"
            />
            <path
              d="M2.23438 13.2072C2.23438 10.0939 4.75822 7.57004 7.87156 7.57004H9.83716C12.9505 7.57004 15.4744 10.0939 15.4744 13.2072C15.4744 14.4606 14.4583 15.4767 13.2049 15.4767H4.50386C3.25046 15.4767 2.23438 14.4606 2.23438 13.2072Z"
              stroke="var(--clr-font)"
              stroke-width="1.42666"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_15_15813">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.855469 0.190002)"
          />
        </clipPath>
        <clipPath id="clip1_15_15813">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.855469 0.190002)"
          />
        </clipPath>
        <clipPath id="clip2_15_15813">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.855469 0.190002)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Bgeye = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_15_15800)">
        <g clip-path="url(#clip1_15_15800)">
          <path
            d="M15.7908 2.22223L17.1158 3.54723L3.74953 16.9185L2.42453 15.5922L4.17578 13.8397C2.57203 12.5572 1.48828 10.891 1.48828 9.56973C1.48828 8.29848 2.56078 6.70723 4.15328 5.41973C5.87828 4.02473 7.97828 3.16348 10.0433 3.16348C11.3433 3.16348 12.6558 3.50223 13.8983 4.11473L15.7908 2.22223ZM18.5983 9.56973C18.5983 10.8447 17.5883 12.4447 16.067 13.7122C14.377 15.1197 12.2545 15.9747 10.042 15.9747C9.21817 15.9737 8.39852 15.8572 7.60703 15.6285L7.52453 15.6047L8.87203 13.9985C9.25953 14.066 9.64953 14.101 10.0433 14.101C11.7895 14.101 13.497 13.4122 14.867 12.271C16.0033 11.3247 16.7233 10.1835 16.7233 9.56973C16.7233 9.13598 16.257 8.31973 15.4583 7.51348L15.3733 7.42848L16.6858 6.08848C17.8608 7.23973 18.5983 8.50848 18.5983 9.56973ZM5.33328 6.87598C4.13578 7.84473 3.36328 8.99098 3.36328 9.56973C3.36328 10.2622 4.22203 11.521 5.51078 12.5022L7.36078 10.6522C6.92762 9.56478 7.18326 8.32386 8.01096 7.49616C8.83866 6.66846 10.0796 6.41282 11.167 6.84598L12.4795 5.53348C11.7057 5.21566 10.8785 5.04769 10.042 5.03848C8.44328 5.03848 6.74328 5.73598 5.33328 6.87598Z"
            fill="#D1D1D2"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_15_15800">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.376953)"
          />
        </clipPath>
        <clipPath id="clip1_15_15800">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.376953)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Copy = () => {
  return (
    <svg
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 3.75001L13.625 3.75C14.8331 3.75 15.8125 4.72938 15.8125 5.9375V13.75C15.8125 14.2677 16.2323 14.6875 16.75 14.6875C17.2677 14.6875 17.6875 14.2677 17.6875 13.75V5.9375C17.6875 3.69384 15.8686 1.875 13.625 1.875L8 1.87501C7.48225 1.87501 7.0625 2.29474 7.0625 2.81251C7.0625 3.33028 7.48225 3.75001 8 3.75001ZM6.125 4.68751C4.74429 4.68751 3.625 5.80679 3.625 7.1875V15.625C3.625 17.0057 4.74429 18.125 6.125 18.125H12.375C13.7557 18.125 14.875 17.0057 14.875 15.625V7.1875C14.875 5.80679 13.7557 4.68751 12.375 4.68751H6.125Z"
        fill="#566FFF"
      />
    </svg>
  );
};

export const Book = () => {
  return (
    <svg
      class="fill_dark_to_white"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 17.2263H10.7877L11.5407 16.5907C13.3204 15.0899 15.5991 14.3126 17.925 14.4128C18.0041 14.4163 18.0831 14.4038 18.1572 14.376C18.2313 14.3482 18.299 14.3057 18.3562 14.251C18.4134 14.1963 18.459 14.1306 18.4902 14.0579C18.5214 13.9851 18.5375 13.9068 18.5376 13.8277V4.65582H20V17.2263ZM0 4.6557H1.46305V13.8276C1.46296 13.9068 1.47895 13.9851 1.51004 14.0579C1.54112 14.1308 1.58667 14.1965 1.64391 14.2512C1.70115 14.3059 1.7689 14.3484 1.84305 14.3762C1.91721 14.4039 1.99622 14.4163 2.07531 14.4127C4.40121 14.3124 6.67987 15.0898 8.45953 16.5907L9.21262 17.2264H0L0 4.6557ZM3.01492 2.79676L2.63438 2.77539V13.2274L2.97781 13.2436C5.13078 13.3406 7.19984 14.1069 8.89672 15.4355L9.49016 15.8993L9.33953 5.81336L9.24481 5.7118C7.61905 3.97687 5.38862 2.93323 3.01492 2.79676ZM17.3661 2.77539L16.9855 2.79676C14.535 2.93735 12.2404 4.04487 10.6059 5.87605L10.5128 5.98078L10.6599 15.7711L11.2273 15.341C12.9011 14.0692 14.9226 13.3375 17.0226 13.2434L17.3661 13.2272V2.77539Z"
        fill="black"
        fill-opacity="0.5"
      />
    </svg>
  );
};

export const Code = () => {
  return (
    <svg
      width="61"
      height="48"
      viewBox="0 0 61 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.498047" width="59.99" height="48" rx="6" fill="#566FFF" />
      <g clip-path="url(#clip0_37_17738)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M38.3505 14.3086H25.5911C25.4863 14.3086 25.4007 14.3865 25.4007 14.4817V15.6932C25.4007 15.7884 25.4863 15.8663 25.5911 15.8663H37.3982V30.7509C37.3982 30.8461 37.4839 30.924 37.5887 30.924H38.9217C39.0265 30.924 39.1122 30.8461 39.1122 30.7509V15.0009C39.1122 14.618 38.7717 14.3086 38.3505 14.3086ZM35.3034 17.0778H23.1153C22.6939 17.0778 22.3535 17.3872 22.3535 17.7701V29.2516C22.3535 29.4355 22.4345 29.6107 22.5773 29.7405L26.7027 33.4898C26.755 33.5374 26.8145 33.5764 26.8788 33.6088V33.6499H26.9788C27.0621 33.6781 27.1502 33.6932 27.2407 33.6932H35.3034C35.7247 33.6932 36.0651 33.3838 36.0651 33.0009V17.7701C36.0651 17.3872 35.7247 17.0778 35.3034 17.0778ZM26.8766 31.4475L24.827 29.5826H26.8766V31.4475ZM34.3511 32.1356H28.3999V29.0635C28.3999 28.5854 27.9738 28.1981 27.4477 28.1981H24.0674V18.6356H34.3511V32.1356Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_37_17738">
          <rect
            width="17.2727"
            height="20"
            fill="white"
            transform="translate(21.8574 14)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Searchicon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.61606 1.20312C3.89944 1.20312 0.886719 4.21584 0.886719 7.93247C0.886719 11.6491 3.89944 14.6618 7.61606 14.6618C9.21884 14.6618 10.6909 14.1013 11.8469 13.1658L14.449 15.7679C14.5819 15.9007 14.7621 15.9754 14.95 15.9754C15.1379 15.9754 15.3181 15.9007 15.4509 15.7679C15.5838 15.635 15.6584 15.4548 15.6584 15.2669C15.6584 15.079 15.5838 14.8988 15.4509 14.7659L12.8489 12.1639C13.8194 10.9674 14.3479 9.47304 14.3454 7.93247C14.3454 4.21584 11.3327 1.20312 7.61606 1.20312ZM2.30356 7.93247C2.30356 4.99837 4.68197 2.61997 7.61606 2.61997C10.5502 2.61997 12.9286 4.99837 12.9286 7.93247C12.9286 10.8666 10.5502 13.245 7.61606 13.245C4.68197 13.245 2.30356 10.8666 2.30356 7.93247Z" fill="#1D1D1D" />
    </svg>
  );
};
